import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { INK, LINE, MUTED } from './homeTheme';

/** Statistica del mese: icona, valore grande, etichetta e una riga di contesto. */
export default function StatCard({ icon, color, label, value, unit, sub, loading }) {
  return (
    <Box sx={{ bgcolor: 'var(--rt-paper)', border: `1px solid ${LINE}`, borderRadius: 4, p: 2.25, height: '100%', boxSizing: 'border-box' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.5 }}>
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: 2,
            bgcolor: `${color}1F`,
            color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& svg': { fontSize: 20 },
          }}
        >
          {icon}
        </Box>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: MUTED }}>{label}</Typography>
      </Box>
      {loading ? (
        <>
          <Skeleton width="55%" height={40} />
          <Skeleton width="80%" />
        </>
      ) : (
        <>
          <Typography sx={{ fontSize: 30, fontWeight: 800, color: INK, lineHeight: 1.1 }}>
            {value}
            {unit && (
              <Typography component="span" sx={{ fontSize: 16, fontWeight: 600, color: MUTED, ml: 0.5 }}>
                {unit}
              </Typography>
            )}
          </Typography>
          <Typography sx={{ fontSize: 12.5, color: MUTED, mt: 0.5 }}>{sub}</Typography>
        </>
      )}
    </Box>
  );
}
